(function () {
  'use strict';

  function bootGallery(gallery) {
    if (!gallery || gallery.__tuppGalleryBooted) return;
    gallery.__tuppGalleryBooted = true;
    gallery.setAttribute('data-tupp-gallery-ready', 'true');

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-figure]'));
    var previous = gallery.querySelector('[data-tupp-gallery-prev]');
    var next = gallery.querySelector('[data-tupp-gallery-next]');
    var count = gallery.querySelector('[data-tupp-gallery-count]');
    var product = gallery.closest('[data-touch-up-pen-product]') || document;
    var preview = product.querySelector('[data-tupp-gallery-preview]');
    var previewContent = preview && preview.querySelector('[data-tupp-gallery-preview-content]');
    var current = Math.max(0, slides.findIndex(function (slide) {
      return slide.getAttribute('data-gallery-selected') === 'true';
    }));
    var pointerStart = null;

    function renderPreview(index) {
      if (!preview || !previewContent || slides.length < 2) {
        if (preview) preview.hidden = true;
        return;
      }

      var sourceSlide = slides[index];
      var sourceImage = sourceSlide && sourceSlide.querySelector('img');
      if (!sourceImage) {
        preview.hidden = true;
        return;
      }

      var previewImage = document.createElement('img');
      previewImage.src = sourceImage.currentSrc || sourceImage.getAttribute('src');
      previewImage.alt = '';
      previewImage.loading = 'eager';
      previewImage.width = 4096;
      previewImage.height = 4096;
      previewImage.setAttribute('aria-hidden', 'true');
      previewContent.replaceChildren(previewImage);
      preview.hidden = false;
      preview.setAttribute('data-preview-index', String(index));
      preview.setAttribute('aria-label', 'View pen product image ' + (index + 1) + ' of ' + slides.length);
    }

    function select(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var selected = slideIndex === current;
        slide.setAttribute('data-gallery-selected', String(selected));
        slide.setAttribute('aria-hidden', String(!selected));
        slide.setAttribute('tabindex', selected ? '0' : '-1');
      });
      if (count) count.textContent = (current + 1) + ' / ' + slides.length;
      renderPreview((current + 1) % slides.length);
    }

    if (previous) previous.addEventListener('click', function (event) {
      event.stopPropagation();
      select(current - 1);
    });
    if (next) next.addEventListener('click', function (event) {
      event.stopPropagation();
      select(current + 1);
    });
    if (preview) preview.addEventListener('click', function () { select(current + 1); });

    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        select(current - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        select(current + 1);
      }
    });

    gallery.addEventListener('pointerdown', function (event) {
      if (event.target && event.target.closest('button')) return;
      pointerStart = { x: event.clientX, y: event.clientY };
    });
    gallery.addEventListener('pointerup', function (event) {
      if (!pointerStart) return;
      if (event.target && event.target.closest('button')) {
        pointerStart = null;
        return;
      }
      var x = event.clientX - pointerStart.x;
      var y = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(x) < 48 || Math.abs(x) < Math.abs(y)) return;
      select(x < 0 ? current + 1 : current - 1);
    });
    gallery.addEventListener('pointercancel', function () { pointerStart = null; });

    select(current);
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-tupp-gallery]')).forEach(bootGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
